// extracted by mini-css-extract-plugin
export default {"greeting":"Navigation_greeting__-Kv2N","navbar":"Navigation_navbar__TNx-C"};